import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MaintenanceService } from '../services/maintenance/maintenance.service';

/**
 * Manda a `/mantenimiento` cuando hay mantenimiento activo y esta navegación no está
 * exenta (super admin, ruta exenta, vuelta de pasarela o compra en curso; ver
 * `maintenance-flow.util.ts`). Devuelve un `UrlTree` y no `navigate + false`, para que
 * un deep link no quede con la URL en la barra y la vista vacía (mismo criterio que
 * `permission-user.guard.ts`).
 */
export const maintenanceGuard: CanActivateFn = async (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean | UrlTree> => {
  const maintenance = inject(MaintenanceService);
  if (await maintenance.shouldRedirect(state.url)) {
    return maintenance.maintenanceUrlTree(state.url);
  }
  return true;
};

export const maintenanceCanActivateChild: CanActivateChildFn = (route, state) => maintenanceGuard(route, state);
